import { render, staticRenderFns } from "./SessionHeader.vue?vue&type=template&id=6d967c03&"
import script from "./SessionHeader.vue?vue&type=script&lang=js&"
export * from "./SessionHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports